<div
    class="folding-cube-container"
    style="font-family: Roboto, sans-serif; height: 100%; display: flex; justify-content: center; align-items: center"
>
    <div style="display: flex; flex-direction: row; align-items: center">
        <img alt="RaxBooker icoon" src="./assets/img/raxbooker_icon_32.png" style="margin: 0 auto; margin-right: 8px" />
        <p style="font-size: 2em">Rax<span style="font-weight: bold">Booker</span></p>
    </div>

    <div class="sk-folding-cube">
        <div class="sk-cube1 sk-cube"></div>
        <div class="sk-cube2 sk-cube"></div>
        <div class="sk-cube4 sk-cube"></div>
        <div class="sk-cube3 sk-cube"></div>
    </div>
    <h3>Pagina laden ..</h3>
</div>
